import { siteResolver } from 'lib/site-resolver';
import { getSiteRoot } from './getSiteRoot';
import { getGraphQLClientAsync } from 'lib/graphql-client-factory/manual-config';

export async function getSiteId(siteName?: string, language?: string) {
  // Resolve site based on hostname
  const site = siteName ? siteResolver.getByName(siteName) : siteResolver.getByHost('');
  const client = await getGraphQLClientAsync();

  const siteRoot = await getSiteRoot(site!.name, language || site!.language);

  const profileSiteIdResult = await client.request<ProfileSiteIdQueryResponse>(
    PROFILE_SITE_ID_QUERY,
    {
      itemID: siteRoot?.path + '/Settings/Site Settings',
      language: language || site!.language,
    }
  );

  const profileSiteId = profileSiteIdResult.root?.profileSiteId?.value;
  return profileSiteId;
}

type ProfileSiteIdQueryResponse = {
  root?: {
    profileSiteId?: {
      value: string;
    };
  };
};
const PROFILE_SITE_ID_QUERY = `
  query ($itemID: String!, $language: String!) {
    root: item(path: $itemID, language: $language) {
      ... on SiteSettings {
        profileSiteId {
          value
        }
      }
    }
  }
`;
